<template>
  <v-dialog v-model="dialog" width="700">
    <template v-slot:activator="{ on, attrs }">
      <i-btn class="btn-type-05 mr-2" v-bind="attrs" v-on="on">
        질문하기
      </i-btn>
    </template>
    <v-card class="modal-pop modal-type-01">
      <v-card-title class="modal-title">{{ $t('Q&A 문의하기') }}</v-card-title>
      <vue-custom-scrollbar class="modal-scroll">
        <v-form ref="form">
          <v-card-text class="modal-contents">
            <v-row class="ma-0">
              <v-col class="pa-0">
                <p class="guide-01 mb-4">
                  {{
                    $t('채용담당자가 내용을 확인 후 바로 답변해 드리겠습니다.')
                  }}
                </p>
                <v-row class="ma-0 mb-2">
                  <i-combobox
                    v-model="cqaAnnoId"
                    :items="announces"
                    item-text="title"
                    item-value="annoId"
                    outlined
                    hide-details
                    dense
                    label="공고"
                    class="box-type-01"
                  ></i-combobox>
                </v-row>
                <v-row class="ma-0 mb-2">
                  <i-combobox
                    v-model="cqaCategory"
                    :items="qnaTypes"
                    outlined
                    hide-details
                    dense
                    label="질문구분"
                    class="box-type-01"
                  ></i-combobox>
                </v-row>
                <v-row class="ma-0 mb-2">
                  <i-text-field
                    v-model="cqaTitle"
                    label="제목"
                    outlined
                    hide-details
                    dense
                    class="box-type-01"
                  ></i-text-field>
                </v-row>
                <v-row class="ma-0 mb-2">
                  <i-textarea
                    v-model="cqaContent"
                    label="내용"
                    hint="본문 내용에 개인정보를 포함한 내용을 작성하지 마시기 바랍니다."
                    outlined
                    hide-details
                    dense
                    no-resize
                    class="box-type-textarea"
                  ></i-textarea>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </vue-custom-scrollbar>
      <v-card-actions class="modal-btn">
        <i-btn class="btn-type-01" @click="dialog = false">
          닫기
        </i-btn>
        <i-btn class="btn-type-02" :disabled="!canSave" @click="saveQna()">
          문의하기
        </i-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getAuthJson, postAuthJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';

export default {
  components: { vueCustomScrollbar },
  mixins: [DialogMixin, LoadingMixin],
  data() {
    return {
      cqaAnnoId: '',
      cqaCategory: '',
      announces: [],
      qnaTypes: [
        '채용공고',
        '지원서 작성',
        '회사정보',
        '지원서 파기요청',
        '기타',
      ],
      cqaTitle: '',
      cqaContent: '',
      dialog: false,
    };
  },
  watch: {
    dialog: function() {
      if (!this.dialog) {
        this.initDialog();
      }
    },
  },
  created() {
    this.getQnaBaseInfo();
  },
  methods: {
    saveQna() {
      if (this.$refs.form && this.$refs.form.validate()) {
        this.showLoading();

        const p = {
          cqaCompanyName: '',
          cqaAnnoId: this.cqaAnnoId.annoId,
          cqaCategory: this.cqaCategory,
          cqaTitle: this.cqaTitle,
          cqaContent: this.cqaContent,
        };

        postAuthJson('api/v1/' + this.$route.params.tenantKey + '/save/qna', p)
          .then(res => {
            if (res.data != null && res.data.hasOwnProperty('status')) {
              var m = null;
              if (res.data.status === 'OK') {
                m = { message: '저장되었습니다.' };
              } else {
                m = { message: res.data.message };
              }

              this.dialog = false;
              this.$showAlert(m);
              this.hideLoading();

              this.$emit('save');
            }
          })
          .catch(error => {
            this.hideLoading();
            console.log(error.response);
          });
      }
    },
    getQnaBaseInfo() {
      try {
        getAuthJson(
          'api/v1/' + this.$route.params.tenantKey + '/qna/annos',
          {},
        ).then(res => {
          if (res.data.hasOwnProperty('annos')) this.announces = res.data.annos;
        });
      } catch (error) {
        console.log(error);
      }
    },
    initDialog() {
      this.$refs.form.resetValidation();
      this.cqaAnnoId = '';
      this.cqaCategory = '';
      this.cqaTitle = '';
      this.cqaContent = '';
    },
  },
  computed: {
    canSave() {
      return this.cqaAnnoId.annoId && (this.cqaTitle || this.cqaContent);
    },
  },
};
</script>
<style>
.modal-pop-qna-add .headline {
  font-size: 18px !important;
  font-weight: 700 !important;
  border-bottom: 1px solid #d5d8dc !important;
}

.modal-pop-qna-add .i-select .v-input__slot {
  min-height: 38px !important;
}

.modal-pop-qna-add .v-label {
  font-size: 14px !important;
  color: #9ca3ab !important;
}

.modal-pop-qna-add .i-select__selection {
  font-size: 14px !important;
}
</style>
